<template>
  <div class="content mt-56">
    <van-tabs v-model="active" sticky @change="typeSelect">
      <van-tab
        v-for="(item, index) in typeList"
        :key="index"
        :title="item.name"
      ></van-tab>
    </van-tabs>
    <div class="nodata-container " v-if="!couponList.length">
      <img src="@/static/coupon_empty.png" alt />
      <div class="S6 T3">暂无此类型优惠券</div>
    </div>
    <ul class="payment-mode-list" v-else>
      <CouponItem
        v-for="(item, index) in couponList"
        :key="index"
        :couponItem="item"
      ></CouponItem>
    </ul>
  </div>
</template>
<script>
import { ref, reactive, onMounted, toRefs } from '@vue/composition-api'
import api from '@/api/api'
import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'
import { openurl } from '@em/ym'
import ym from '@/assets/js/ym.js'
import { Tab, Tabs } from 'vant'
import CouponItem from './components/CouponItem.vue'
dayjs.extend(isBetween)

export default {
  name: 'ValidCoupon',
  components: {
    vanTab: Tab,
    vanTabs: Tabs,
    CouponItem
  },
  data() {
    return {
      active: 0
    }
  },
  setup() {
    const couponList = ref({})
    const state = reactive({
      viewState: '',
      activeType: null,
      typeList: [
        { name: '全部', value: null },
        { name: '全场券', value: 1 },
        { name: '品类券', value: 2 },
        { name: '单品券', value: 3 }
      ]
    })

    onMounted(() => {
      getCouponData().then(() => {
        showMenuItems()
      })
    })

    async function getCouponData() {
      const type = state.typeList.find(a => a.value === state.activeType).value
      const { detail, result } = await api.coupon.getCouponApi(
        {
          type: type,
          direction: state.viewState ? 2 : 0,
          statusList: [0]
        },
        state.viewState
      )
      if (result.code === 0) {
        couponList.value = detail.list.map(ite => {
          const currentDate = dayjs()
          ite.btnActive = dayjs(currentDate).isBetween(
            ite.validFrom,
            ite.validEnd
          )
          return ite
        })
        state.viewState = result.viewState
      }
    }

    function typeSelect(name, title) {
      state.activeType = state.typeList.find(a => a.name === title).value
      state.viewState = ''
      getCouponData()
    }

    function showMenuItems() {
      ym.showMenuItems({
        menuItems: [
          {
            callback: () => {
              const url = `${
                process.env.VUE_APP_ENV === 'staging'
                  ? 'https://yktpre.emoney.cn/yktstatic'
                  : 'https://yktstatic.emoney.cn'
              }/ykthtml/yktapp/?route=disabled-coupon`
              openurl(url)
            },
            title: '查看无效券'
          }
        ]
      })
    }

    return {
      ...toRefs(state),
      couponList,
      typeSelect,
      dayjs
    }
  }
}
</script>
<style lang="scss" scoped>
.content {
  padding: 0 30px;
  display: flex;
  flex-direction: column;
  height: 100vh;

  .title {
    padding-bottom: 20px;
  }
}
.flex {
  display: flex;
}
.mt-5 {
  margin-top: 5px;
}
.text-center {
  text-align: center;
}

.payment-mode-list {
  list-style: none;
  padding: 0;
  margin: 0;
  margin-top: 20px;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  .payment-mode {
    position: relative;
    height: 156px;
    display: flex;
    align-items: center;
    margin-bottom: 21px;
    background: url('./images/bg1.png') no-repeat center;
    background-size: cover;

    .icon {
      width: 44px;
      height: 100%;
      margin-right: 20px;
      background: no-repeat center;
      background-size: contain;
    }

    .click-btn {
      position: absolute;
      right: 24px;
      top: calc(50% - 22px);
      bottom: 0;
      width: 120px;
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #858585;
      border-radius: 8px;
      &.is-active {
        border: 1px solid #e64c2e;
      }
    }

    .left-count {
      flex: 0 0 180px;
    }
    .right-count {
      flex: 0 0 100%;
      padding-left: 54px;
    }
    .name {
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: bold;
      margin-bottom: 20px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 300px;
    }
  }
}
.min-limit {
  margin-top: 18px;
  padding-left: 10px;
}
.filter-row {
  align-items: flex-start;
  display: flex;
  margin-bottom: 6px;
  margin-top: 40px;
}

.filter-row-content {
  display: flex;
  align-items: center;
  align-content: space-between;
  flex-flow: row wrap;
  justify-content: space-between;
  flex: 1;
  div {
    font-size: 24px;
    color: #858585;
  }
  .select-item {
    border: 1px solid #0079ff;
    color: #0079ff;
    background: #ffffff;
  }
}
.filter-item-wrap {
  width: 22%;
  margin-right: 3%;
  &:nth-child(4n) {
    margin-right: 0;
  }
}
.filter-item {
  height: 50px;
  color: #858585;
  background-color: rgba(85, 85, 85, 0.1);
  border-radius: 5px;
  text-align: center;
  line-height: 50px;
  letter-spacing: 1px;
  cursor: pointer;
  flex: none;
  box-sizing: border-box;
}

.item-bottom-10 {
  margin-bottom: 24px;
}

.nodata-container {
  width: 100%;
  height: 800px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.nodata-container img {
  width: 402px;
  height: 194px;
  margin-bottom: 26px;
}
</style>
